var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('Loader',{staticStyle:{"margin":"auto"}}):_c('div',{ref:"paypal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }